import Axios from "../../axios-default"

const namespaced = true;

const state = () => ({
  loading: false,
  saving: false,
  syncTime: null,
  syncPeriod: 1000 * 60 * 0.25,
  itemsPerPage: 20,
  icons: ['mdi-exclamation','mdi-wifi-off','mdi-alert-circle-outline','mdi-information-variant'],
  notifications: [],
  notificationsNotApproved: [],
  showAlerts: false,
  menuOpened: false
});

const getters = {
  counter(state) {
    return state.notificationsNotApproved.length;
  },
  countByController: (state, getters) => (id) => {
    return state.notificationsNotApproved.filter(item => item.controllerId == id).length
  },
  byController: (state) => (id) => {
    return state.notifications.filter(item => item.controllerId == id)
  },
  notApproved(state) {
    //return state.notifications.filter(item => item.approved !== true)
    return state.notificationsNotApproved;
  },
  notApprovedIds(state) {
    return state.notificationsNotApproved.map(item => item.id)
  }
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading
  },
  setSaving(state, saving) {
    state.saving = saving
  },
  setSyncTime(state, syncTime) {
    state.syncTime = syncTime
  },
  setNotifications(state, data) {
    state.notifications = data
  },
  setApproved(state) {
    var approved = JSON.parse(localStorage.getItem('approved'));
    
    if (state.notifications.length > 0 && approved) {
      var ile = state.notifications.length, i, tmp = [];
      
      for (i=0; i < ile; i++) {
        state.notifications[i].approved = (approved.includes(state.notifications[i].id)) ? true : false;
        if (!approved.includes(state.notifications[i].id)) {
          tmp.push(state.notifications[i]);
        }
      }
      state.notificationsNotApproved = tmp;
      
    } else {
      state.notificationsNotApproved = state.notifications;
    }
  }
};

const actions = { 
  async getNotifications ({commit, rootGetters, state}, {controllerId, forced}) {
    try {
      if (!state.loading && (forced || state.syncTime === null || new Date().getTime() - state.syncTime > state.syncPeriod)) {
        commit('setLoading', true);
        const formData = new URLSearchParams();
        if (controllerId) {
          formData.append('controllerId', controllerId);
        }
        formData.append('token', rootGetters.token);
        formData.append('startIndex', 1);
        formData.append('itemsPerPage', 50);
        
        const res = await Axios.post('/api/sterownik/alarm/lista?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
          if (forced == true) {
            commit("alert", {color: "error", text: '0'}, { root: true });
          }
        } else {
          commit('setNotifications', res.data);
          commit('setSyncTime', new Date().getTime());
          commit('setApproved');
          commit('setLoading', false);
        }
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  approveNotification({commit}, id) {
    var approved = JSON.parse(localStorage.getItem('approved')),
    toApproveIds = [id];

    if (approved) {
      approved = [...approved, ...toApproveIds];
    } else {
      approved = toApproveIds;
    }
    
    approved = approved.filter((v, i, a) => a.indexOf(v) === i);
    localStorage.setItem('approved', JSON.stringify(approved));
    commit('setApproved');
  },
  approveNotifications({commit}, notificationsToApprove) {
    var approved = JSON.parse(localStorage.getItem('approved')),
    toApproveIds = [];

    notificationsToApprove.forEach(function(el) {
      toApproveIds.push(el.id)
    });

    if (approved) {
      approved = [...approved, ...toApproveIds];
    } else {
      approved = toApproveIds;
    }
    
    approved = approved.filter((v, i, a) => a.indexOf(v) === i);
    localStorage.setItem('approved', JSON.stringify(approved));
    commit('setApproved');
  },
  openDialogAlerts({commit}) {
    commit('setApproved');
  }
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}